import Scrollbar from 'smooth-scrollbar';

let elem = document.querySelector('.portfolio-gallery');
let emptyBlock = document.querySelector('.portfolio-gallery__empty');
let resetFilter = document.getElementById('reset-filter');
let paged = 1;
let totalPages;
let categoryTotalPages;
let isLoading = false;
let activeCategory = null;
let scrollInterval = null;

async function loadMoreItems() {
  const response = await fetch(`${themeVars['home']}/wp-json/wp/v2/portfolio?per_page=4&page=${paged}&order=asc&acf_format=standard`);
  if (!response.ok) return [];
  const data = await response.json();
  totalPages = response.headers.get('X-WP-TotalPages');
  return Array.isArray(data) ? data : [];
}

async function categoryFilter(catId, page = 1) {
  const response = await fetch(`${themeVars['home']}/wp-json/wp/v2/portfolio?per_page=4&page=${page}&portfolio_cat=${catId}&order=asc&acf_format=standard`);
  if (!response.ok) return [];
  const data = await response.json();
  categoryTotalPages = response.headers.get('X-WP-TotalPages');
  return Array.isArray(data) ? data : [];
}

function renderItems(dataPromise) {
  return dataPromise.then((data) => {
    if (!Array.isArray(data) || data.length === 0) {
      emptyBlock.classList.add('active');
      return;
    } else {
      emptyBlock.classList.remove('active');
    }

    const shuffled = data.sort(() => Math.random() - 0.5);
    const addedItems = [];

    shuffled.forEach((el) => {
      const item = document.createElement('div');
      item.classList.add('portfolio-gallery__item');
      item.innerHTML = `
        <a href="${el.acf.portfolio_cpt_link ? el.acf.portfolio_cpt_link.url : '#'}" target="${el.acf.portfolio_cpt_link ? el.acf.portfolio_cpt_link.target : '_self'}">
          <div class="portfolio-gallery__img">
            <img src="${el.acf.portfolio_cpt_image.url}" alt="${el.acf.portfolio_cpt_image.alt}">
          </div>
          <div class="portfolio-gallery__content">
            ${el.acf.portfolio_cpt_logo ? `<div class="portfolio-gallery__content--logo"><img src="${el.acf.portfolio_cpt_logo.url}" alt="${el.acf.portfolio_cpt_logo.url}"></div>` : ''}
            <div class="portfolio-gallery__content--content">
              <h2>${el.title.rendered}</h2>
              ${el.content.rendered || ''}
            </div>
          </div>
        </a>
      `;
      addedItems.push(item);
    });

    const imagePromises = addedItems.flatMap(item =>
      Array.from(item.querySelectorAll('img')).map(img =>
        new Promise(resolve => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = img.onerror = resolve;
          }
        })
      )
    );

    return Promise.all(imagePromises).then(() => {
      addedItems.forEach(item => {
        elem.appendChild(item);
      });
    });
  });
}

function clearGallery() {
  document.querySelectorAll('.portfolio-gallery__item').forEach((item) => item.remove());
}

function infiniteScrollWithScrollbar() {
  const waitForScrollbar = setInterval(() => {
    const scrollbars = Scrollbar.getAll();
    const scrollbar = scrollbars.length > 0 ? scrollbars[0] : null;

    if (scrollbar) {
      clearInterval(waitForScrollbar);

      scrollInterval = setInterval(() => {
        if (isLoading) {
          return;
        }

        const scrollY = scrollbar.offset.y;
        const viewportHeight = window.innerHeight;
        const galleryOffsetTop = elem.offsetTop;
        const galleryHeight = elem.offsetHeight;
        const scrolledBottom = scrollY + viewportHeight;

        const currentTotalPages = activeCategory ? categoryTotalPages : totalPages;
        if (
          scrolledBottom >= galleryOffsetTop + galleryHeight - 100 &&
          paged <= currentTotalPages
        ) {
          isLoading = true;
          if (activeCategory) {
            renderItems(categoryFilter(activeCategory, paged)).then(() => {
              paged++;
              isLoading = false;
            });
          } else {
            renderItems(loadMoreItems()).then(() => {
              paged++;
              isLoading = false;
            });
          }
        }
      }, 100);
    }
  }, 100);
}

function stopInfiniteScroll() {
  if (scrollInterval) {
    clearInterval(scrollInterval);
    scrollInterval = null;
  }
}

function filterItems() {
  const filterLinks = document.querySelectorAll('.portfolio__lists li a');

  filterLinks.forEach((link) => {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      const isAlreadyActive = this.classList.contains('active');
      const catId = this.getAttribute('data-category-id');

      stopInfiniteScroll();
      elem.classList.add('is-loading');
      filterLinks.forEach(el => el.classList.remove('active'));
      clearGallery();
      emptyBlock.classList.remove('active');
      paged = 1;

      if (isAlreadyActive) {
        activeCategory = null;
        isLoading = true;
        renderItems(loadMoreItems()).then(() => {
          paged++;
          isLoading = false;
          elem.classList.remove('is-loading');
          infiniteScrollWithScrollbar();
        });
      } else {
        activeCategory = catId;
        this.classList.add('active');
        isLoading = true;
        renderItems(categoryFilter(catId, 1)).then(() => {
          paged++;
          isLoading = false;
          elem.classList.remove('is-loading');
          infiniteScrollWithScrollbar();
        });
      }
    });
  });
}

if (resetFilter) {
  resetFilter.addEventListener('click', (e) => {
    e.preventDefault();
    stopInfiniteScroll();
    paged = 1;
    activeCategory = null;
    elem.classList.add('is-loading');
    clearGallery();
    emptyBlock.classList.remove('active');

    document.querySelectorAll('.portfolio__lists li a').forEach((el) => el.classList.remove('active'));

    isLoading = true;
    renderItems(loadMoreItems()).then(() => {
      paged++;
      isLoading = false;
      elem.classList.remove('is-loading');
      infiniteScrollWithScrollbar();
    });
  });
}

renderItems(loadMoreItems()).then(() => {
  paged++;
  elem.classList.remove('is-loading');
  infiniteScrollWithScrollbar();
});
filterItems();
